<template>
  <div class="mainBody">
    <el-tabs v-model="activeName" class="tabs" @tab-click="handleClick">
      <el-tab-pane label="我提交的" name="mySubmit"></el-tab-pane>
      <el-tab-pane label="待审批的" name="myAgency"></el-tab-pane>
      <el-tab-pane label="已审批的" name="myFinished"></el-tab-pane>
    </el-tabs>
    <div class="main">
      <leftList ref="leftList" :active-name="activeName" @getRightTableData="getRightTableData"
        @getFlowBusinessId="getFlowBusinessId" @getFileList="getFileList"></leftList>
      <rightTable ref="rightTable" @getTableData="getTableData"></rightTable>
    </div>
  </div>
</template>

<script>
import leftList from "./components/leftList.vue";
import rightTable from "./components/rightTable.vue";
export default {
  name: "CheckRegion",
  components: { leftList, rightTable },
  mixins: [],
  props: {},
  data() {
    return {
      activeName: "mySubmit",
      businessId: '',
      currentNodeName: ''
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$refs.leftList.getFlowList(this.activeName, 1);
    },
    handleClick() {
      this.$refs.leftList.keyWords = "";
      this.$refs.leftList.getFlowList(this.activeName, 1);
    },
    getRightTableData({ businessId, currentNodeName }) {
      this.businessId = businessId;
      this.currentNodeName = currentNodeName;
      this.$refs.rightTable.setTableData(businessId, currentNodeName);
    },
    getFlowBusinessId(flowBusinessId) {
      this.$refs.rightTable.setFlowBusinessId(flowBusinessId);
    },
    // 右侧搜索框清空时重新复制
    getTableData() {
      this.$refs.rightTable.setTableData(this.businessId, this.currentNodeName);
    },
    getFileList() {
      // 点同意时获取文件列表
      const list = this.$refs.rightTable.getTableData();
      this.$refs.leftList.setFileList(list);
    }
  }
};
</script>

<style scoped lang="scss">
.mainBody {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  /deep/ .el-tabs {
    .el-tabs__header {
      margin: 0 !important;
      .el-tabs__nav-scroll {
        padding: 0 var(--big-space);
        box-sizing: border-box;
      }
      .el-tabs__item {
        color: var(--info-color);
        height: 46px;
        line-height: 46px;
      }
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }
  .main {
    display: flex;
    align-items: center;
    width: 100%;
    height: 1px;
    flex-grow: 1;
  }
}
</style>
